import React, { useContext } from 'react';
import { AppContext } from '../Home';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faDownload } from '@fortawesome/free-solid-svg-icons';
import html2canvas from 'html2canvas';
import WaterDisruption from '../templates/WaterDisruption';
import PlannedShutdown from '../templates/PlannedShutdown';
import EmergencyShutdown from '../templates/EmergencyShutdown';
import BulkLineMaintenance from '../templates/BulkLineMaintenance';
import TelephoneLinesDown from '../templates/TelephoneLinesDown';
import General from '../templates/General';

 
const Notice = (props) => { 

const { setSlider } = useContext(AppContext);
    
    if(props.notice.category_id == 6) {
        return ( <>
        <FontAwesomeIcon icon={faDownload} className="download-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <FontAwesomeIcon icon={faXmark} className="close-icon" onClick={() => { setSlider(true) }} />
        <WaterDisruption notice={props.notice} />
        </> );
    }

    if(props.notice.category_id == 14) {
        return ( <>
        <FontAwesomeIcon icon={faDownload} className="download-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <FontAwesomeIcon icon={faXmark} className="close-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <PlannedShutdown notice={props.notice} />
        </> );
    }

    if(props.notice.category_id == 117) {
        return ( <>
        <FontAwesomeIcon icon={faDownload} className="download-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <FontAwesomeIcon icon={faXmark} className="close-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <EmergencyShutdown notice={props.notice} />
        </> );
    }

    if(props.notice.category_id == 119) {
        return ( <>
        <FontAwesomeIcon icon={faDownload} className="download-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <FontAwesomeIcon icon={faXmark} className="close-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <BulkLineMaintenance notice={props.notice} />
        </> );
    }

    if(props.notice.category_id == 118) {
        return ( <>
        <FontAwesomeIcon icon={faDownload} className="download-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <FontAwesomeIcon icon={faXmark} className="close-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <TelephoneLinesDown notice={props.notice} />
        </> );
    }

    if(props.notice.category_id == 5) { 
        return ( <>
        <FontAwesomeIcon icon={faDownload} className="download-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <FontAwesomeIcon icon={faXmark} className="close-icon" onClick={() => { downloadImage(props.notice.notice_title) }} />
        <General notice={props.notice} />
        </> );
    } 
}

const downloadImage = async (title) => {
    const element = document.getElementById('share'),
    canvas = await html2canvas(element),
    data = canvas.toDataURL('image/jpg'),
    link = document.createElement('a');

    link.href = data;
    link.download = title + '.jpg';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

export default Notice;

